import { produce } from 'immer';
import emitter from './emitter';
import getEntry from './getEntry';

function upsert(ctx, endpoint, input, options, fn) {
  const entry = getEntry(ctx, endpoint, input, options);
  if (entry) {
    entry.value = produce(entry.value, fn);
    emitter.emit('update', { endpoint });
  }
}

export default upsert;
